import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { OPEN_BIR_SEAL_BADGE_EVENT } from 'utils/birSealBadgeEvent';
import LandingRegistrationBannerChrome from './LandingRegistrationBannerChrome';
import styles from './HomepageRefreshPopup.module.scss';

const STORAGE_KEY = 'hub:homepageAnnouncement:v1';

function readDismissed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function writeDismissed(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
}

function HomepageRefreshPopup() {
  const [bannerVisible, setBannerVisible] = useState(() => !readDismissed());
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const onOpenSeal = () => {
      setModalOpen(true);
    };
    window.addEventListener(OPEN_BIR_SEAL_BADGE_EVENT, onOpenSeal);
    return () =>
      window.removeEventListener(OPEN_BIR_SEAL_BADGE_EVENT, onOpenSeal);
  }, []);

  const handleDismissBanner = useCallback(() => {
    writeDismissed();
    setBannerVisible(false);
  }, []);

  const handleOpenCertificates = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      {bannerVisible ? (
        <LandingRegistrationBannerChrome
          onView={handleOpenCertificates}
          onDismiss={handleDismissBanner}
        />
      ) : null}

      <Modal
        show={modalOpen}
        onHide={handleCloseModal}
        centered
        animation
        className={styles.modalRoot}
        dialogClassName={styles.dialog}
        contentClassName={styles.content}
        backdropClassName={styles.backdrop}
        aria-label="BIR and NPC registration seals"
      >
        <Modal.Body className={styles.body}>
          <button
            type="button"
            className={styles.dismissIcon}
            onClick={handleCloseModal}
            aria-label="Close"
          >
            ×
          </button>
          <div className={styles.sealsWrap}>
            <div className={styles.birCell}>
              <img
                className={styles.birImage}
                src={`${import.meta.env.BASE_URL}images/homepage-popup.webp`}
                alt="Bureau of Internal Revenue registered seal badge"
                decoding="async"
              />
            </div>
            <div className={styles.npcCell}>
              <img
                className={styles.npcSeal}
                src={`${import.meta.env.BASE_URL}images/npc-dpo-dps-seal.png`}
                alt="National Privacy Commission DPO/DPS registered seal"
                decoding="async"
              />
            </div>
          </div>
          <div className={`${styles.footer} ${styles.footerOnlyClose}`}>
            <button
              type="button"
              className={styles.primaryBtn}
              onClick={handleCloseModal}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default HomepageRefreshPopup;
